export const restaurantInfo = {
  name: 'ASIAN KITCHEN BALEN',
  nameJa: 'アジアンキッチン バレン',
  address: '愛知県春日井市○○町1-23',
  phone: '0568-00-0000',
  lunchHours: '11:00〜14:30（L.O. 14:00）',
  dinnerHours: '17:00〜22:00（L.O. 21:30）',
  closedDay: '毎週火曜日',
  seats: 'カウンター席 8席 / テーブル席 24席',
  parking: '店舗隣接 6台分',
  payment: '現金・各種クレジットカード・電子マネー対応',
  tabelogUrl: 'https://tabelog.com/',
  lineUrl: 'https://line.me/ja/',
};

export const foodMenuItems = [
  {
    id: 1,
    name: 'ナシゴレン',
    nameEn: 'Nasi Goreng',
    description: 'インドネシア産バラチャン（発酵海老ペースト）とタマリンドを使用したスパイス炒飯。目玉焼きとエビチップを添えて提供。',
    price: 1320,
    image: 'https://readdy.ai/api/search-image?query=Nasi%20goreng%20Indonesian%20spiced%20fried%20rice%20on%20white%20ceramic%20plate%20with%20fried%20egg%20on%20top%20prawn%20crackers%20cucumber%20tomato%20garnish%20dark%20wooden%20restaurant%20table%20warm%20amber%20lighting%20professional%20food%20photography%20close%20up%20appetizing%20presentation&width=600&height=600&seq=food1&orientation=squarish',
  },
  {
    id: 2,
    name: 'ガパオライス',
    nameEn: 'Gapao Rice',
    description: 'ホーリーバジルと鶏ひき肉を使用したタイの炒め物。ナムプラー・オイスターソース・唐辛子で味付け。目玉焼きとジャスミンライスを添えて提供。',
    price: 1210,
    image: 'https://readdy.ai/api/search-image?query=Thai%20gapao%20rice%20holy%20basil%20chicken%20minced%20meat%20stir%20fry%20with%20crispy%20fried%20egg%20on%20white%20plate%20jasmine%20rice%20colorful%20bell%20peppers%20dark%20wooden%20background%20authentic%20Thai%20cuisine%20professional%20food%20photography%20warm%20tones&width=600&height=600&seq=food2&orientation=squarish',
  },
  {
    id: 3,
    name: 'パッタイ',
    nameEn: 'Pad Thai',
    description: 'タイの米粉麺（センレック）をエビ・豆腐・もやしとともにタマリンドソースで炒めた料理。砕いたピーナッツとライムを添えて提供。',
    price: 1210,
    image: 'https://readdy.ai/api/search-image?query=Authentic%20pad%20thai%20rice%20noodles%20with%20shrimp%20tofu%20bean%20sprouts%20in%20round%20white%20bowl%20crushed%20peanuts%20lime%20wedge%20green%20onions%20garnish%20dark%20stone%20background%20Thai%20street%20food%20photography%20warm%20orange%20tones&width=600&height=600&seq=food3&orientation=squarish',
  },
  {
    id: 4,
    name: 'フォー',
    nameEn: 'Phở',
    description: 'ベトナムのライスヌードルスープ。牛骨とスターアニス・シナモン・クローブを数時間煮出したブロスに、薄切り牛肉とフレッシュハーブを添えて提供。',
    price: 1210,
    image: 'https://readdy.ai/api/search-image?query=Vietnamese%20pho%20beef%20noodle%20soup%20in%20white%20deep%20bowl%20with%20thin%20sliced%20beef%20rice%20noodles%20fresh%20herbs%20basil%20bean%20sprouts%20aromatic%20steam%20rising%20dark%20wooden%20restaurant%20table%20warm%20lighting%20professional%20food%20photography&width=600&height=600&seq=food4&orientation=squarish',
  },
  {
    id: 5,
    name: 'トムカーガイ',
    nameEn: 'Tom Kha Gai',
    description: 'レモングラス・ガランガル・コブミカンの葉を使用したタイのスープ。鶏肉とマッシュルームを、ナムプラーとライム果汁で調味したスープで煮込んで提供。',
    price: 990,
    image: 'https://readdy.ai/api/search-image?query=Tom%20kha%20gai%20Thai%20coconut%20milk%20soup%20with%20chicken%20mushrooms%20lemongrass%20galangal%20kaffir%20lime%20leaves%20in%20white%20bowl%20garnished%20with%20chili%20cilantro%20dark%20background%20professional%20food%20photography%20warm%20creamy%20tones&width=600&height=600&seq=food5&orientation=squarish',
  },
];

export const spaceFeatures = [
  {
    id: 1,
    title: '店内の空間',
    heading: 'アジアンリゾートをイメージした\n落ち着いた内装',
    body: '籐（ラタン）素材のチェアと天然木のテーブルを組み合わせた内装。アンバー系のペンダントライトが照らす空間に、観葉植物を配置しています。カウンター8席・テーブル24席を用意し、おひとりでもグループでもご利用いただけます。',
    image: 'https://readdy.ai/api/search-image?query=Upscale%20Asian%20restaurant%20interior%20resort%20lounge%20atmosphere%20rattan%20chairs%20dark%20teak%20wooden%20tables%20bamboo%20pendant%20lights%20tropical%20plants%20warm%20amber%20candlelight%20dark%20turquoise%20accent%20walls%20cozy%20intimate%20dining%20space%20architectural%20interior%20photography%20no%20people&width=900&height=600&seq=space1&orientation=landscape',
    reverse: false,
  },
  {
    id: 2,
    title: '料理へのこだわり',
    heading: '現地のスパイスと\n伝統的な調理法',
    body: 'レモングラス・ガランガル・コブミカンの葉・バラチャン等、産地を確認した香辛料と食材を使用しています。ナシゴレンの炒めご飯には発酵海老ペーストを、フォーのブロスには牛骨を長時間煮出す工程を採用。各料理の素材と製法を誠実に再現することを基本としています。',
    image: 'https://readdy.ai/api/search-image?query=Asian%20restaurant%20kitchen%20wooden%20counter%20with%20spread%20of%20colorful%20fresh%20spices%20lemongrass%20galangal%20kaffir%20lime%20leaves%20turmeric%20star%20anise%20cinnamon%20chili%20dried%20herbs%20on%20dark%20wood%20surface%20culinary%20ingredient%20flat%20lay%20professional%20food%20photography&width=900&height=600&seq=space2&orientation=landscape',
    reverse: true,
  },
];
